export default {
    props: {
        load: {
            type: Boolean,
            default: true
        }
    },
    created() {
        var obj = {
            pageIndex: 1,
            pageSize: 15
        };
        if (this.queryConfig.length) {
            this.queryConfig.forEach(item => {
                if (item.key1 && item.key2) {
                    obj[item.key] = "";
                    obj[item.key1] = "";
                    obj[item.key2] = "";
                } else {
                    obj[item.key] = item.value || "";
                }
            });
        }
        this.params = obj;
        console.log(this.params)
    },
    mounted() {
        if (this.load) {
            this.loadDataInit();
            this.getList();
        }
    },
    methods: {
        loadDataInit() { },
        dblClick() { },
        add() {
            this.addFlag = true;
        },

        openEdit(type, title) {
            this.editData.title = title;
            if (type == "isAdd") {
                this.editData.type = "新增";
            } else {
                this.editData.type = "修改"
            }
            this.editData.visible = true
        },
        // 搜索
        searchData() {
            this.searchFrom.PageIndex = 1;
            this.getList();
        },
        // 重置
        clearSearch() {
            this.searchFrom.time_period = null
            this.$refs.form.resetFields()
        },
        // 页码改变
        changePage(page) {
            if (typeof page == "object") {
                this.tablePage.PageIndex = page.current
            } else {
                this.tablePage.PageIndex = page
            }
            this.getList();
        },
        // 改变每页显示数据条数
        changePageSize(PageSize) {
            this.tablePage.PageIndex = 1;
            this.tablePage.PageSize = PageSize;
            this.getList();
        },
        setList(res) {
            if (res.Code == 0) {
                this.tableData = res.Data;
                this.tablePage.total = res.Total;
            }
        }

    },
    data() {
        return {
            initParams: {
                pageIndex: 1,
                pageSize: 15
            },
            params: {
                pageIndex: 1,
                pageSize: 15
            },
            list: [],
            total: 0,
            queryConfig: [],
            tableData: [],
            searchFrom: {},
            addFlag: false,
            editData: {
                title: "",
                type: "",
                visible: false,
                loadData: null,
                handle: function () { }
            },
            // tablePage: {
            //     total: 0,
            //     PageIndex: 1,
            //     PageSize: 20
            // }
        }
    }
}
